import SearchIcon from "@mui/icons-material/Search";
import { Button, Grid, InputAdornment, TextField } from "@mui/material";
import { useAsignaturas } from "../../../../context/SuperAdmin/OASContexts/AsignaturasContext";

const HeaderAsignaturas = () => {
  const {
    toggleCreateModal,
    selectedAsignaturas,
    toggleDeleteModal,
    searchText,
    setSearchText,
  } = useAsignaturas();

  return (
    <Grid container spacing={4} display={"flex"} alignItems={"center"}>
      {/* Formulario de búsqueda */}
      <Grid item xs={6} md={6}>
        {/* Search bar */}
        <TextField
          size="small"
          variant="outlined"
          placeholder="Ej: Matemáticas"
          value={searchText}
          onChange={(e) => setSearchText(e.target.value)}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
          }}
        />
      </Grid>
      <Grid
        item
        xs={6}
        md={6}
        display={"flex"}
        alignItems={"center"}
        justifyContent={"flex-end"}
        gap={2}
      >
        <Button
          variant="outlined"
          onClick={() => toggleDeleteModal(true)}
          disabled={!selectedAsignaturas.length}
          sx={{
            borderRadius: 14,
            border: "1px solid #336B87",
            color: "#336B87",
            "&:hover": {
              backgroundColor: "#336B87",
              color: "#EEF3F6",
            },
          }}
        >
          Eliminar
        </Button>
        <Button
          variant="contained"
          onClick={() => toggleCreateModal(true)}
          sx={{ background: "#336B87" }}
        >
          Crear asignatura
        </Button>
      </Grid>
    </Grid>
  );
};

export default HeaderAsignaturas;
